<template>
  
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.meddra coding") }}</h2>
    </div>
    <div class="closebutton mt-1">
            <span class="tooltip-wrapper pointer" style="float:right">
              <i class="cursor-pointer fa fa-times" @click.prevent="closemodal()"></i>
              <span class="custom-tooltip closetooltipposition">Close</span>
             </span>
          </div>
  </div>
  <div class="wrapper wrapper-content">
    <!-- <div class="ibox-body">
      <div class="ibox-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex mb-3 justify-content-between align-items-center">
              <div class="table-responsive">
                <table
                  class="table table-striped table-bordered dark-table-head mb-0"
                >
                  <thead>
                    <tr>
                      <th>Field Name</th>
                      <th>Verbatim Value</th>
                      <th>LLT Code</th>
                      <th>LLT Name</th>
                      <th>PT Code</th>
                      <th>PT Name</th>
                      <th>HLT Code</th>
                      <th>HLT Name</th>
                      <th>HLGT Code</th>
                      <th>HLGT Name</th>
                      <th>SOC Code</th>
                      <th>SOC Name</th>            
                      <th>Verified By</th>
                      <th>Verified On</th>
                      <th>Verify</th>
                      <th class="text-center">Change</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="meddra in meddraenabledfields" :key="meddra.id">
                      <td>{{ meddra.FieldName }}</td>
                      <td>
                        <span>
                          {{
                            showFull.meddraId
                              ? meddra.VerbatimValue
                              : truncateText(meddra.VerbatimValue, 30)
                          }}
                        </span>
                        <span
                          v-if="
                            meddra.VerbatimValue &&
                            meddra.VerbatimValue.length > 30
                          "
                          class="show-toggle ml-1"
                          @click="toggleShow(meddra, 'VerbatimValue')"
                        >
                          {{
                            showFull[meddra._id + "_VerbatimValue"]
                              ? "Show less"
                              : "Show more"
                          }}
                        </span>
                      </td>
                      <td>{{ meddra.LltCode }}</td>
                      <td>
                        <span>
                          {{
                            showFull[meddra._id + "_LltName"]
                              ? meddra.LltName
                              : truncateText(meddra.LltName, 30)
                          }}
                        </span>
                        <span
                          v-if="meddra.LltName && meddra.LltName.length > 30"
                          class="show-toggle ml-1"
                          @click="toggleShow(meddra, 'LltName')"
                        >
                          {{
                            showFull[meddra._id + "_LltName"]
                              ? "Show less"
                              : "Show more"
                          }}
                        </span>
                      </td>
                      <td>{{ meddra.PtCode }}</td>
                      <td>
                        <span>
                          {{
                            showFull[meddra._id + "_PtName"]
                              ? meddra.PtName
                              : truncateText(meddra.PtName, 30)
                          }}
                        </span>
                        <span
                          v-if="meddra.PtName && meddra.PtName.length > 30"
                          class="show-toggle ml-1"
                          @click="toggleShow(meddra, 'PtName')"
                        >
                          {{
                            showFull[meddra._id + "_PtName"]
                              ? "Show less"
                              : "Show more"
                          }}
                        </span>
                      </td>
                      <td>{{ meddra.HltCode }}</td>
                      <td>
                        <span>
                          {{
                            showFull[meddra._id + "_HltName"]
                              ? meddra.HltName
                              : truncateText(meddra.HltName, 30)
                          }}
                        </span>
                        <span
                          v-if="meddra.HltName && meddra.HltName.length > 30"
                          class="show-toggle ml-1"
                          @click="toggleShow(meddra, 'HltName')"
                        >
                          {{
                            showFull[meddra._id + "_HltName"]
                              ? "Show less"
                              : "Show more"
                          }}
                        </span>
                      </td>

                      <td>{{ meddra.HlgtCode }}</td>
                      <td>{{ meddra.HlgtName }}</td>
                      <td>{{ meddra.SocCode }}</td>
                      <td>
                        <span>
                          {{
                            showFull[meddra._id + "_SocName"]
                              ? meddra.SocName
                              : truncateText(meddra.SocName, 30)
                          }}
                        </span>
                        <span
                          v-if="meddra.SocName && meddra.SocName.length > 30"
                          class="show-toggle ml-1"
                          @click="toggleShow(meddra, 'SocName')"
                        >
                          {{
                            showFull[meddra._id + "_SocName"]
                              ? "Show less"
                              : "Show more"
                          }}
                        </span>
                      </td>                   
                      <td>{{ meddra.VerifiedBy }}</td>
                      <td>{{ meddra.VerifiedOn }}</td>
                      <td v-if="meddra.Verified != true">
                        <button
                          class="btn btn-primary btn-sm py-0 py-0"
                          @click="verifyMeddra(meddra)"
                        >
                          Verify
                        </button>
                      </td>
                      <td v-else class="sticky-column">Verified</td>
                      <td class="text-center">
                        <i
                          v-if="meddra.Verified != true"
                          class="fa fa-edit edit-delete"
                          @click="openMeddra(meddra)"
                        >
                        </i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="row px-0">
      <!-- Search & Filters Panel -->
      <div class="col-lg-3 mb-1 px-1">
        <div class="card shadow-sm">
          <div class="card-header bg-white">
            <h6 class="card-title mb-0 py-1">
              <i class="fa fa-search me-2"></i>Search & Filters
            </h6>
          </div>
          <div class="card-body pt-1">
            <div class="mb-1 d-flex justify-content-end">
                <p class="mb-0">MedDRA Version:&nbsp;
                  <span class="badge bg-primary code-badge">
                  <strong>{{meddraVersion}}</strong>
                  </span>
                 </p>
            </div>
            <!-- Search Box -->
            <div class="mb-3 border-top pt-2">
              <label for="searchInput" class="form-label small text-muted mb-1">Search Terms</label>
              <div class="input-group">
                <input type="text" class="form-control" id="searchInput" v-model="searchTerm" placeholder="Enter term name or code..." />
                <button class="btn btn-primary py-0" type="button">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>

            <!-- Category Filter -->
            <div class="mb-2 border-top pt-1">
              <label class="form-label small text-muted mb-0"><i class="fa fa-filter me-1"></i>Filter by Fields</label>
              <div class="list-group list-group-flush">
              <label v-for="cat in categories" :key="cat" class="list-group-item d-flex justify-content-between align-items-center py-1 ps-0">
                <span>{{ cat === 'all' ? 'All Fields' : cat }}</span>
                <input class="form-check-input" type="radio" name="categoryFilter" :value="cat" v-model="selectedCategory" @change="selectedTerm = null" />
              </label>
              </div>
            </div>

            <!-- Verification Filter -->
            <div class="mb-0 border-top pt-1">
              <label class="form-label small text-muted mb-0"><i class="fa fa-filter me-1"></i>Filter by Verification</label>
              <div class="list-group list-group-flush">
              <label class="list-group-item d-flex justify-content-between align-items-center py-1 ps-0">
                <span>All</span>
                <input class="form-check-input" type="radio" value="all" v-model="selectedVerification" @change="selectedTerm = null" />
              </label>
              <label class="list-group-item d-flex justify-content-between align-items-center py-1 ps-0">
                <span>Verified</span>
                <input class="form-check-input" type="radio" value="verified" v-model="selectedVerification" @change="selectedTerm = null" />
              </label>
              <label class="list-group-item d-flex justify-content-between align-items-center py-1 ps-0">
                <span>Unverified</span>
                <input class="form-check-input" type="radio" value="unverified" v-model="selectedVerification" @change="selectedTerm = null" />
              </label>
              </div>
            </div>


          </div>
        </div>
      </div>

      <!-- Main Content Area -->
      <div class="col-lg-9 px-0">
        <div class="row">
          <!-- Gastrointestinal Disorders Section -->
          <div v-for="field in filteredFields" :key="field.FieldName" class="col-12 mb-1">
            <div class="card shadow-sm">
              
              <div class="card-header d-flex justify-content-between align-items-center">
                <div>
                  <h4 class="m-0">{{ field.FieldName }}</h4>
                  <span>Verbatim Value: <b>{{ field.VerbatimValue }}</b></span>
                </div>
                <div class="d-flex gap-1">
                  <!-- If Verified -->                 
                  <template v-if="field.Verified">
                    <!-- Show Verified info -->
                    <span class="badge bg-success">Verified</span>
                    <small class="text-muted ms-2">
                      By : {{ field.VerifiedBy }} | {{ new Date(field.VerifiedOn).toLocaleString()}}
                    </small>
                  </template>
                  <template v-else>
                    <!-- Show Verify and Edit buttons -->
                    <button class="btn btn-sm btn-outline-success py-0" @click="verifyMeddra(field)">Verify</button>
                    <button class="btn btn-sm btn-outline-primary py-0" @click="openMeddra(field)">Edit</button>
                  </template>

                </div>
              </div>

              <div class="card-body">
                <div class="row g-2">
                  <div class="col-md-6 col-lg-4 px-1" v-for="level in ['Llt','Pt','Hlt','Hlgt','Soc']" :key="level">
                    <div class="card term-card h-100">
                      <div class="card-body p-2">
                        <div class="d-flex justify-content-between align-items-start mb-0">
                          <p class="card-title mb-0">Level: <strong>{{ level.toUpperCase() }}</strong></p>
                          <p class="mb-0">Code: <span class="badge bg-primary">{{ field[level + 'Code'] }}</span></p>
                        </div>
                        <p class="card-title mb-0">Term: <strong>{{ field[level + 'Name'] }}</strong></p>
                        <button class="btn btn-sm btn-outline-primary w-100 py-0" v-if="level ==='Llt'" @click="showDetails(field, level)">View Details</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Detail Panel -->
        
        <div class="row" id="termDetails">
          <div class="col-12">
            <div class="card shadow-sm detail-panel">
              
              <div class="card-header bg-white d-flex justify-content-between align-items-center">
                <h6 class="card-title mb-0 py-1">Audit Trail Info</h6>
                <button class="btn btn-sm btn-outline-primary py-0" @click="showFormpopup()">
                  <i class="fa fa-eye"></i> View Form
                </button>
              </div>


              <div class="card-body" v-if="selectedTerm">
                <!-- Field Name -->
                <h8 class="mb-2">Field Label: <strong>{{ selectedTerm.field.FieldName }}</strong></h8>

                <!-- Verbatim Value -->
                <p class="mb-2">Verbatim Value: <strong>{{ selectedTerm.field.VerbatimValue }}</strong></p>

                <!-- Table -->
                <table class="table table-sm table-bordered">
                  <thead class="table-light">
                    <tr>
                      <th>Coding Mode</th>
                      <th>LLT Term</th>
                      <th>Medical Code</th>
                      <th>Status</th>
                      <th>Action By</th>
                      <th>Date & Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Verified entry (if exists) -->
                    <tr v-if="selectedTerm.field.VerifiedOn">
                      <td>{{ selectedTerm.field.CodingMode }}</td>
                      <td>{{ selectedTerm.field.LltName }}</td>
                      <td><span class="badge bg-primary">{{ selectedTerm.code }}</span></td>
                      <td><span class="badge bg-success">Verified</span></td>
                      <td>{{ selectedTerm.field.VerifiedBy }}</td>
                      <td>{{ new Date(selectedTerm.field.VerifiedOn).toLocaleString() }}</td>
                    </tr>

                    <!-- Predicted entry -->
                    <tr>
                      <td>Auto</td>
                      <td>{{ selectedTerm.field.PredictedLltName }}</td>
                      <td><span class="badge bg-primary">{{ selectedTerm.code }}</span></td>
                      <td><span class="badge bg-secondary">Predicted</span></td>
                      <td>System</td>
                      <td>{{ new Date(selectedTerm.field.PredictedOn).toLocaleString() }}</td>
                    </tr>
                  </tbody>
                </table>

                
              </div>

              <div class="card-body text-muted text-center" v-else>
                Select a Term to View Details
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <meddraPopup v-if="showMeddraModal" :showMeddraModal="showMeddraModal" :meddraItem="meddrafields" :formsId="formId"
    :templateId="tempId" @closeModal="closeLltModal" />

  <showformmodel
  v-if="setshowFormModal"
    :formid="formId"
    :currentformstatus="'Completed'"
    @closeformModal="closeFormModal"
  />
</template>


<script src="./meddraViewer.js" type="text/javascript">
</script>
<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";
.previousbtn,
.nextbtn {
  margin: 0;
  border-radius: 0px;
  border: 0.5px solid #eeeeee;
}
.page-links {
  border-radius: 0px;
}
.form-select {
  border-radius: 0 !important;
}
.form-select:focus {
  border-color: #145faf !important;
  box-shadow: 0 0 0 !important;
}
.form-check-input {
    position: relative;
    margin-top: 0.3rem;
    margin-left: -1.25rem;
}
.show-toggle {
  color: #000; /* black text */
  font-weight: 500;
  cursor: pointer;
}
.show-toggle:hover {
  text-decoration: underline;
}
.ml-1 {
  margin-left: 0.25rem;
}
.sticky-column {
  position: sticky;
  right: 0;
  background-color: #fff;
  z-index: 10;
  border-left: 1px solid #dee2e6;
}
.dark-table-head > thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}
.dark-table-head thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}
.category-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.term-card {
  transition: all 0.3s ease;
  border-left: 4px solid #0d6efd;
}

.term-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-left-color: #667eea;
}

.code-badge {
  font-size: 0.75rem;
}

.detail-panel {
  background-color: #f8f9fa;
  border-radius: 10px;
}

.stat-card {
  background: white;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
}
.card-header {
  padding: .1rem 1rem;
}
.card-header h6{
  font-size: .8rem !important;
}
.list-group-flush>.list-group-item {
    border-width: 0 0 1px solid #ebebeb;
}
</style>